import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';
import LoadingIndicator from "flarum/components/LoadingIndicator";

import AnnouncementManagementAddModal from "./modal/AnnouncementManagementAddModal";
import AnnouncementListItem from "./AnnouncementListItem";

export default class AnnouncementSidebarComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.viewType = this.attrs.viewType;
    this.loading = true;
    this.moreResults = false;
    this.u2diAnnouncementList = [];

    this.loading = true;
    this.statusFilters = Stream("-1");
    this.listSort = Stream("desc");
    this.loadResult();

    const _this = this;
    $(window).off("u2diAnnouncementRefresh").on("u2diAnnouncementRefresh",function(e){
      _this.filterItem(e);
    })
  }

  oncreate(vnode) {
    super.oncreate(vnode);

  }

  view() {
    const mapModule = this.mapModule;
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const u2diAnnouncementList = this.u2diAnnouncementList;
    const _this = this;

    let counter = 0;
    let loading;

    if (this.loading) {
      loading = LoadingIndicator.component({ size: "large" });
    }

    let sideBarContentContainierStyle = "";

    if(u2diUserType9===true){
      sideBarContentContainierStyle = "height: calc(100vh - 345px)";
    }else{
      if(u2diUserType9===false && u2diUserType0===false){
        sideBarContentContainierStyle = "min-height: 360px;height: calc(100vh - 320px)";
      }else{
        sideBarContentContainierStyle = "min-height: 380px;height: calc(100vh - 300px)";
      }
    }

    return (
      <div>
        {this.viewType==="normal" && (
          <div className="u2diMapSideBarTitleContainier">
            <div className="u2diMapSideBarTitle">
              {app.translator.trans(u2diUserType9===true?"ziven-u2di.forum.map-sidebar-announcement-title-admin":"ziven-u2di.forum.map-sidebar-announcement-title")}
            </div>

            {u2diUserType9===true && (
              <div className="u2diMapSideBarMagageArea u2diInfoItemContainer">
                <div style="width:155px;position: relative;">
                  <Select className="u2diDataSelectList" value={this.statusFilters()}
                    style = "width:155px"
                    disabled={this.loading}
                    options={{
                      "-1":app.translator.trans("ziven-u2di.forum.map-announcement-filter-all"),
                      "0":app.translator.trans("ziven-u2di.forum.map-announcement-filter-processing"),
                      "1":app.translator.trans("ziven-u2di.forum.map-announcement-filter-done"),
                      "2":app.translator.trans("ziven-u2di.forum.map-announcement-filter-delete"),
                    }}
                    onchange={(e) => { 
                      this.statusFilters(e); 
                      this.filterItem(e);
                    }}
                  />
                  <div className="u2diDataSort" onclick={(e) => { this.sortItem(e) }}>
                    <i style={this.listSort()==="asc"?"color:var(--primary-color)":""} class="fas fa-sort-up"></i>
                    <i style={this.listSort()==="desc"?"color:var(--primary-color)":""} class="fas fa-sort-down"></i>
                  </div>
                </div>
                <div>
                {Button.component({
                    style:'font-size: 12px;font-weight: normal;',
                    disabled:this.loading,
                    className: 'Button Button--primary',
                    onclick: () => {
                      app.modal.show(AnnouncementManagementAddModal,{callback:function(){
                        _this.statusFilters("-1"); 
                        _this.listSort("desc");
                        _this.filterItem();
                      }});
                    }
                  },
                  app.translator.trans('ziven-u2di.forum.button-new-announcement')
                )}
                </div>
              </div>
            )}

            {u2diUserType9===false && u2diUserType0===false && (
              <div className="u2diMapSideBarSubTitle">
                <i className="fab fa-weixin"></i>
                <i className="fas fa-phone-alt" style="padding: 0px 3px;"></i>
                13205719527
              </div>
            )}

            <div style={sideBarContentContainierStyle} className="u2diMapSideBarContentContainier">
              {u2diAnnouncementList.map((announcementData) => {
                return (
                  <div id={"u2diAnnouncement"+announcementData.id()} style="padding-top: 10px;">
                    {AnnouncementListItem.component({ announcementData })}
                  </div>
                );
              })}

              {!this.loading && u2diAnnouncementList.length===0 && (
                <div>
                  <div style="font-size:1.4em;color: var(--muted-more-color);text-align: center;height: 300px;line-height: 100px;">{app.translator.trans("ziven-u2di.lib.list-empty")}</div>
                </div>
              )}

              {!loading && this.hasMoreResults() && (
                <div className="u2di-loadMore" style="text-align:center;padding:20px">
                  <Button className={'Button Button--primary'} disabled={this.loading} loading={this.loading} onclick={() => this.loadMore()}>
                    {app.translator.trans('ziven-u2di.lib.load-more')}
                  </Button>
                </div>
              )}

              {loading && <div className="u2di-loadMore">{loading}</div>}
            </div>
          </div>
        )}

        {this.viewType==="mobile" && (
          <div>
            <div className="u2diMapSideBarMobileSliderArea">
              <div className="u2diMapSideBarMobileSliderContainer">
                <div className="swiper u2diMapSideBarMobileSwiper">
                  <div className="swiper-wrapper">
                    {u2diAnnouncementList.map((announcementData) => {
                      if(counter<3){
                        counter++;

                        return (
                          <div className="swiper-slide">
                            <div className="u2diMapSideBarMobileSwiperSlide">{announcementData.text()}</div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="u2diMapSideBarMobileContentArea">
              <div className="u2diMapSideBarMobileContentContainer">
                {u2diAnnouncementList.map((announcementData) => {
                  return (
                    <div style="padding-top: 5px;">
                      {AnnouncementListItem.component({ announcementData })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  sortItem(e){
    const listSort = this.listSort();

    if(listSort==="desc"){
      this.listSort("asc");
    }else if(listSort==="asc"){
      this.listSort("desc");
    }

    this.u2diAnnouncementList = [];
    this.loading = true;
    m.redraw();
    this.loadResult();
  }

  filterItem(){
    this.u2diAnnouncementList = [];
    this.loading = true;
    m.redraw();
    this.loadResult();
  }

  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.u2diAnnouncementList, results);
    this.loading = false;
    m.redraw();

    setTimeout(function(){
      new Swiper('.u2diMapSideBarMobileSwiper',{
        spaceBetween: 30,
        direction: "vertical",
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    },100);

    return results;
  }

  loadMore() {
    this.loading = true;
    this.loadResult(this.u2diAnnouncementList.length);
  }

  hasMoreResults() {
    return this.moreResults;
  }

  loadResult(offset = 0){
    const listSort = this.listSort();
    const filters = {
      status:this.statusFilters(),
    };

    if(listSort!==""){
      filters["sort"] = listSort
    }

    app.store
      .find("u2diAnnouncementList", {
      filter:filters,
      page: {
        offset,
      },
    })
    .catch(() => {})
    .then(this.parseResults.bind(this));
  }

}